import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-col footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-mark">NH</span>
              <div>
                <h3>SocialAgency<span className="footer-logo-accent">@nielshoefner.com</span></h3>
                <p>by Niels Höfner</p>
              </div>
            </div>
            <p className="footer-tagline">
              Strategien, die Marken sichtbar machen – und wachsen lassen.
            </p>
          </div>

          <div className="footer-col">
            <h4>Navigation</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">Über mich</Link></li>
              <li><Link to="/services">Leistungen</Link></li>
              <li><Link to="/preise">Preise</Link></li>
              <li><Link to="/ebook">E-Book</Link></li>
              <li><Link to="/kontakt">Kontakt</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Leistungen</h4>
            <ul>
              <li>Social Media Management</li>
              <li>Content Creation</li>
              <li>Paid Advertising</li>
              <li>Marketing Strategy</li>
              <li>Personal Branding</li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Kontakt</h4>
            <ul className="footer-contact">
              <li>
                <a href="mailto:hoefner.digitalmarketing@gmail.com">
                  hoefner.digitalmarketing@gmail.com
                </a>
              </li>
              <li>
                <a href="https://wa.me/4901604905213" target="_blank" rel="noopener noreferrer">
                  WhatsApp: 0160 4905213
                </a>
              </li>
              <li>
                <a href="https://instagram.com/hoefner.agency" target="_blank" rel="noopener noreferrer">
                  Instagram: @hoefner.agency
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>© {new Date().getFullYear()} SocialAgency@nielshoefner.com – Niels Höfner. Alle Rechte vorbehalten.</p>
            <div className="footer-legal-links">
              <Link to="/impressum">Impressum</Link>
              <span className="separator">·</span>
              <Link to="/datenschutz">Datenschutz</Link>
              <span className="separator">·</span>
              <Link to="/agb">AGB</Link>
            </div>
          </div>
          <p className="footer-quote">Dein Erfolg ist mein Antrieb.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
